import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon } from 'lucide-react';
interface PricingCardProps {
  title: string;
  price: string;
  features: string[];
}
export function PricingCard({
  title,
  price,
  features
}: PricingCardProps) {
  return <div className="bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden" data-id="element-327">
      <div className="p-6 bg-gradient-to-r from-teal-500 to-teal-600 text-center" data-id="element-328">
        <h3 className="text-xl font-bold text-white mb-1" data-id="element-329">{title}</h3>
        <div className="flex justify-center items-baseline my-4" data-id="element-330">
          <span className="text-5xl font-extrabold text-white" data-id="element-331">${price}</span>
          <span className="ml-1 text-xl text-teal-100" data-id="element-332">one-time</span>
        </div>
      </div>
      <div className="p-6" data-id="element-333">
        <ul className="space-y-4 mb-6" data-id="element-334">
          {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-335">
              <div className="flex-shrink-0 w-5 h-5 mt-1" data-id="element-336">
                <CheckIcon className="w-5 h-5 text-teal-500" data-id="element-337" />
              </div>
              <p className="ml-3 text-base text-gray-700" data-id="element-338">{feature}</p>
            </li>)}
        </ul>
        <CTAButton text="Get Started Now" className="w-full text-center py-3 px-4 text-lg font-medium" data-id="element-339" />
      </div>
    </div>;
}